export default __webpack_public_path__ + "static/media/DaimlerCS-Light.41bdfe01.woff";